import { useEffect, useRef } from "react";
import L from "leaflet";
import { useNavigate } from "react-router-dom";

export default function MapView({ discounts, center, activeId, onMarkerClick }) {
    const mapRef = useRef(null);
    const containerRef = useRef(null);
    const markersRef = useRef([]);
    const navigate = useNavigate();

    useEffect(() => {
        if (mapRef.current || !containerRef.current) return;
        const map = L.map(containerRef.current, {
            center: center || [39.5, -98.35],
            zoom: 4,
            zoomControl: true,
            scrollWheelZoom: true,
        });
        L.tileLayer("https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png", {
            attribution: '&copy; OpenStreetMap &copy; CARTO',
            subdomains: "abcd",
            maxZoom: 19,
        }).addTo(map);
        mapRef.current = map;
    }, [center]);

    useEffect(() => {
        const map = mapRef.current;
        if (!map) return;

        markersRef.current.forEach((m) => map.removeLayer(m));
        markersRef.current = [];

        const withCoords = discounts.filter(
            (d) => d.latitude != null && d.longitude != null
        );

        withCoords.forEach((d) => {
            const isActive = d.id === activeId;
            const icon = L.divIcon({
                html: `<div class="custom-marker" style="${
                    isActive
                        ? "background:#00f0ff; box-shadow:0 0 0 6px rgba(0,240,255,0.35);"
                        : ""
                }"></div>`,
                className: "",
                iconSize: [16, 16],
                iconAnchor: [8, 8],
            });
            const marker = L.marker([d.latitude, d.longitude], { icon }).addTo(map);
            marker.bindPopup(
                `<div style="font-family:'IBM Plex Sans',sans-serif;color:#e8eef5;background:#0e1319;padding:6px 8px;min-width:160px;">
                    <div style="font-family:'Oswald',sans-serif;font-weight:700;text-transform:uppercase;color:#c3ff00;font-size:13px;letter-spacing:0.05em;">${d.title}</div>
                    <div style="font-size:11px;color:#94a3b8;margin-top:2px;">${d.business_name} · ${d.city}, ${d.state}</div>
                    <button id="popup-${d.id}" style="margin-top:6px;background:#c3ff00;color:#000;border:none;padding:4px 8px;font-family:'Oswald',sans-serif;text-transform:uppercase;letter-spacing:0.06em;font-size:11px;cursor:pointer;">View Intel</button>
                </div>`
            );
            marker.on("popupopen", () => {
                const btn = document.getElementById(`popup-${d.id}`);
                if (btn) btn.onclick = () => navigate(`/discount/${d.id}`);
            });
            marker.on("click", () => onMarkerClick && onMarkerClick(d.id));
            markersRef.current.push(marker);
        });

        if (withCoords.length > 0) {
            const bounds = L.latLngBounds(
                withCoords.map((d) => [d.latitude, d.longitude])
            );
            map.fitBounds(bounds, { padding: [40, 40], maxZoom: 12 });
        }
    }, [discounts, activeId, navigate, onMarkerClick]);

    useEffect(() => {
        if (mapRef.current && center) {
            mapRef.current.flyTo(center, 11, { duration: 1 });
        }
    }, [center]);

    return (
        <div
            ref={containerRef}
            data-testid="tactical-map"
            className="w-full h-full min-h-[420px] border border-white/10"
        />
    );
}
